import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#00AFF1",
        secondary: "#F1F1F2",
        accent: "#403579",
        error: "#FF6060",
        success: "#5AB55E"
      },
    },
  },
});
